import { api } from "@/api/client"
import { normalizePhoneForApi } from "@/lib/phone"

export async function sendPhoneNumber(phoneNumber: string): Promise<unknown> {
  const { data } = await api.post("/auth/send", {
    phoneNumber: normalizePhoneForApi(phoneNumber),
  })
  return data
}

export type PersonalDataConsentPayload = {
  documentSlug: string
  documentRevision: number
  source?: string
}

export async function verifySmsCode(
  phoneNumber: string,
  code: string,
  personalDataConsent?: PersonalDataConsentPayload | null
): Promise<{ token?: string; [key: string]: unknown }> {
  const { data } = await api.post("/auth/login", {
    phoneNumber: normalizePhoneForApi(phoneNumber),
    code,
    ...(personalDataConsent ? { personalDataConsent } : {}),
  })
  return data as { token?: string; [key: string]: unknown }
}

export async function fetchUserProfile(): Promise<unknown> {
  const { data } = await api.get("/auth", {
    params: { _t: Date.now() },
  })
  return data
}
